import Model from '../Model'

export default class PPERegister extends Model {

    getDownloadUrl() {
        return route('api.v2.hsqe.ppe-registers.pdf', [this.packageReference, this.id])
    }

    getPrintableUrl() {
        return route('api.v2.hsqe.ppe-registers.download', [this.packageReference, this.id])
    }

    getFormAttributes() {
        return this;
    }

    static parseAttributes(attributes = {}) {
        return attributes
    }

    setAttributes(attributes) {
        super.setAttributes(attributes)
        this.formattedDate = new Date(attributes.date).toLocaleDateString()
        let tokens = [
            attributes.date,
            attributes.formatted_date,
            attributes.givenByName
        ]
        this.tokens = tokens.join('|').toLowerCase();
    }

    async send(attributes = {}) {
        const url = route('api.v2.hsqe.ppe-registers.send', [this.packageReference, this.id])

        let success
        try {
            success = await Http.post(url, attributes)
        } catch (error) {
            return error.response
        }
        const data = await Http.get(route('api.v2.hsqe.ppe-registers', [this.packageReference, this.id]))
        Object.assign(this,data)
        return success;
    }

    async revoke(sendRequestId) {
        const url = route('api.v2.hsqe.ppe-registers.revoke', [this.packageReference, this.id, sendRequestId])
        let success
        try {
            success = await Http.post(url, {})
        } catch (error) {
            return error.response
        }
        const data = await Http.get(route('api.v2.hsqe.ppe-registers', [this.packageReference, this.id]))
        Object.assign(this, data)
        return success;
    }

    async resend(sendRequestId) {
        const url = route('api.v2.hsqe.ppe-registers.resend', [this.packageReference, this.id, sendRequestId])
        let success
        try {
            success = await Http.post(url, {})
        } catch (error) {
            return error.response
        }
        const data = await Http.get(route('api.v2.hsqe.ppe-registers', [this.packageReference, this.id]))
        Object.assign(this, data)
        return success;
    }

    static async find(packageReference, id) {
        const data = await Http.get(route('api.v2.hsqe.ppe-registers', [packageReference, id]))
        return this.make(data);
    }

    static async all(packageReference = null) {
        const params = {}
        const data = await Http.get(route('api.v2.hsqe.ppe-registers.list', [packageReference]), {params})
        return this.make(data)
    }

    static async create(packageReference, id, attributes = {}) {
        const success = await Http.post(route('api.v2.hsqe.ppe-registers.create', [packageReference, id]), attributes);
        const data = await Http.get(route('api.v2.hsqe.ppe-registers', [packageReference, id]))
        return this.make(data)
    }

    async update(attributes = {}) {
        const url = route('api.v2.hsqe.ppe-registers.store', [this.packageReference, this.id])
        const payload = this.constructor.parseAttributes({...this.getFormAttributes(), ...attributes})
        const success = await Http.put(url, payload)
        const data = await Http.get(route('api.v2.hsqe.ppe-registers', [this.packageReference, this.id]))
        return this.fill(data)
    }

    async requestSignature(personId, to) {
        const url = route('api.v2.hsqe.ppe-registers.request-signature', [this.packageReference, this.id])
        const success = await Http.put(url, {personId, to})
        const data = await Http.get(route('api.v2.hsqe.ppe-registers', [this.packageReference, this.id]))
        return this.fill(data)
    }

    async delete() {
        await Http.delete(route('api.v2.hsqe.ppe-registers.delete', [this.packageReference, this.id]))
    }
}
